import { BrowserModule } from "@angular/platform-browser";
import { NgModule, LOCALE_ID, isDevMode } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { registerLocaleData } from "@angular/common";
import localeDe from "@angular/common/locales/de";

import { NgxBarcodeModule } from "@greatcloak/ngx-barcode";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ActionService } from "./services/action.service";
import { Error404Component } from "./error404/error404.component";
import { LoginModule } from "./login/login.module";
import { ApplicationPool } from "./services/application.pool";
import { PrintModule } from "./print/print.module";
import { EmptyPageService } from "./services/empty-page.service";
import { LoadingComponent } from "./loading/loading.component";
import { DirectivesModule } from "./directives/directives.module";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { ActiveConnectNg2Module } from "active-connect-ng2";
import { HrefService } from "./services/href.service";
import { NavigationService } from "./services/navigation.service";
import { MicroSentryModule } from "@micro-sentry/angular";
import { PushNotificationService } from "./services/push-notification.service";
import { provideServiceWorker } from "@angular/service-worker";

registerLocaleData(localeDe);

@NgModule({
  declarations: [AppComponent, Error404Component, LoadingComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    LoginModule,
    PrintModule,
    NgxBarcodeModule,
    DirectivesModule,
    ActiveConnectNg2Module,
    MicroSentryModule.forRoot({
      dsn: "https://6d1a2c036e6e4986ae64baf473a0725c@glitchtip.srv1.hiptmairit.at/3",
      environment: document.location.host.replace("www.", ""),
      blacklistUrls: ["localhost"],
      ignoreErrors: [
        "Error: NG0100: ExpressionChangedAfterItHasBeenCheckedError",
      ],
    }),
  ],
  providers: [
    NavigationService,
    ActionService,
    ApplicationPool,
    EmptyPageService,
    HrefService,
    PushNotificationService,
    provideServiceWorker("ngsw-worker.js", {
      enabled: !isDevMode(),
      registrationStrategy: "registerWhenStable:3000",
    }),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: LOCALE_ID, useValue: "de-DE" },
  ],
})
export class AppModule {
  public constructor() {}
}
